module.exports = __webpack_public_path__ + "static/media/Gilmer-Outline.ea176b1c.otf";